<app-guest-screening-form
    [guestForm]="guestForm"
    (middleNameToggled)="middleNameToggled()"
    (phoneNumberChanged)="onPhoneNumberChanged($event)"
    [guestScreeningService]="guestScreeningService"
>
</app-guest-screening-form>